import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import * as Yup from "yup";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios from "axios";
import { useFormik } from "formik";
import UserDetailsModel from "../../models/user-security/userdetails-model";
import '../../components/Style/app.css';

interface UserDetailsEditProps {
  data: UserDetailsModel;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const UserDetailsEntry: React.FC<UserDetailsEditProps> = ({ ...props }) => {
  const { data, onClose } = props;
  const title = data?.agentCode ? "Edit User Details" : "Add User Details";
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState<UserDetailsModel>();
  const [agentCode, setAgentCode] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [existingName, setExistingName] = useState<string[]>([]);

  let initialValue: UserDetailsModel = {
    mobile: mobile || '',
    email: email || '',
    isActive: userDetails?.isActive || false,
    entityId: 1,
    entityType: 1,
    unionId: 7,
    userName: userName || '',
    entityCode: "Agent",
    agentCode: "",
    password: ''
  };



  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'agentCode') {
      setAgentCode(value);
    };
    if (name === 'uesrName') {
      setUserName(value);
    };
    if (name === 'mobile') {
      setMobile(value);
    };
    if (name === 'email') {
      setEmail(value);
    }
  }

  const getUserDetailsList = async () => {
    setIsLoading(true);
    const getUserDetails = getEndPoint(API_END_POINT.ADMIN) + `/api/UserDetails/GetUserDetails/${agentCode}`;
    try {

      const response = await getDataWithToken<any>(getUserDetails);
      const userData = response?.data?.result?.[0];
      setUserDetails(userData);

      setUserName(userData?.userName);
      setMobile(userData?.mobile);
      setEmail(userData?.email);
      /* await checkUserDetailsList(userData?.mobile); */
    } catch (error) {
      console.error("Network error:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const checkUserDetailsList = async (mobile: string): Promise<boolean> => {
    try {
      // Make the API call to check if the mobile exists in the database
      const response = await getDataWithToken<any>(getEndPoint(API_END_POINT.ADMIN) + `/api/UserDetails/CheckUserDetails/${mobile}`);
      const checkuserData = response?.data?.result;

      // Assuming checkuserData is an array of existing mobile numbers
      const isDuplicate = checkuserData?.some((item: any) => item.mobile === mobile);
      console.log("Is Duplicate:", isDuplicate)
      if (isDuplicate) {
        alert("User already exist")
      }
      else {

      }
      return isDuplicate; // Return true if the mobile number is found, otherwise false
    } catch (error) {
      console.error("Error during mobile check:", error);
      return false; // In case of an error, we return false (meaning no duplicates found)
    }
  };


  console.log("exist", existingName);

  /*   const validationSchema = Yup.object().shape({
      // name: Yup.string().required("Required"),
      mobile: Yup.string()
        .required("Required")
        .test("check-duplicate-mobile", "Mobile number already exists", (value) => {
 
          return (
            value &&
            !existingName.includes(value) ||
            (mobile && value === mobile) // Allow current name during update
          );
        }),
    });  */

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Mobile number is required")
      .test("check-duplicate-mobile", "Mobile number already exists", async (value) => {
        if (!value) return true;
        try {
          const isDuplicate = await checkUserDetailsList(value);
          return !isDuplicate;
        } catch (error) {
          // Handle error if API call fails
          console.error("Error during validation:", error);
          return false; // Return false in case of error to prevent submission
        }
      }),
  });





  return (
    <>

      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.ADMIN}
        postRoute="User/CreateUser"

      //isUpDateEntityDetails={data?.agentCode ? true : false}
      >
        <div>
          <div className="row">
            <div className="col-6">
              <div className="d-flex align-items-center">
                <div className="mr-2" style={{ flex: 1 }}>
                  {/*  <InputField maxLength={10} label="Agent" name="agentCode" /> */}
                  <label className="agent-label">Agent Code</label>
                  {/*  <div className="form-label">Order Date</div> */}
                  <input
                    type="text"
                    name="agentCode"
                    value={agentCode}
                    onChange={handleChange}
                    className="input-agentbox"
                  />
                </div>
                <button type="button" className="btn btn-primary" style={{ marginTop: "26px", marginLeft: "40px" }} onClick={() => {
                  getUserDetailsList();
                }}
                  disabled={isLoading}>Get
                  {/*  {isLoading ? "Loading..." : "Get"} */}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div><hr /></div>
        <div className="row">
          <div className="col-4">
            {/* <InputField maxLength={100} label="User Name" name="userName" /> */}
            <label className="agent-label">User Name</label>
            {/*  <div className="form-label">Order Date</div> */}
            <input
              type="text"
              name="userName"
              value={userName}
              onChange={handleChange}
              className="input-agentbox"
            />
          </div>
          <div className="col-4">
            {/* <InputField maxLength={100} label="Mobile" name="mobile" /> */}
            <label className="agent-label">Mobile</label>
            {/*  <div className="form-label">Order Date</div> */}
            <input
              type="text"
              name="mobile"
              value={mobile}
              onChange={handleChange}
              className="input-agentbox"
            />
          </div>
          <div className="col-4">
            {/*  <InputField label="E-Mail" name="email" /> */}
            <label className="agent-label">Email</label>
            {/*  <div className="form-label">Order Date</div> */}
            <input
              type="text"
              name="email"
              value={email}
              onChange={handleChange}
              className="input-agentbox"
            />
          </div>
          <div className="col-3" style={{ marginTop: "15px" }}>
            <CheckboxField label="Is Active?" name="isActive" checkstyle={CheckBoxStyle.Normal} />
          </div>

        </div>
      </FormikModelDialog>
    </>
  );
};

export default UserDetailsEntry;
